export const carouselImageFormatter = (
  skuResourceName = "",
  isNewProduct = false
) => {
  if (skuResourceName) {
    return `//kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2F${
      isNewProduct ? "2New" : "Blank"
    }&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is{PAWEB%2F${skuResourceName}}`;
  }
  return "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";
};

export const imageFormatter = skuResourceName => {
  if (skuResourceName) {
    return `https://kohler.scene7.com/is/image/PAWEB/${skuResourceName}`;
  }
  return "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";
};

export const gifLineArtImageFormatter = image => {
  return `https://resources.kohler.com/plumbing/kohlerla/lineart/${image}`;
};

export const checkForNewProducts = dateStr => {
  // Provided date
  const providedDate = new Date(dateStr);

  // Current date
  const currentDate = new Date();

  // Calculate the difference in milliseconds
  const difference = currentDate - providedDate;

  // Convert milliseconds to years
  const millisecondsInYear = 1000 * 60 * 60 * 24 * 365;
  const differenceInYears = difference / millisecondsInYear;

  // Check if the difference is greater than or equal to 1 year
  return differenceInYears < 1;
};

/**
 * Builds a higher-resolution variant of a Scene7 image URL so that the
 * magnifier glass can render a crisp (non-pixelated) zoomed view.
 *
 * The displayed product image is served via Scene7's `$PDPcon$` preset which
 * defaults to a fairly low pixel size. When that same URL is then scaled up
 * inside the magnifier glass it looks blurry. By appending an explicit `wid`
 * (and matching `hei`) modifier after the preset, Scene7 returns a larger
 * source image that stays sharp when magnified.
 */
export const getHiResImageSrc = (src, targetSize = 2000) => {
  if (!src || typeof src !== "string") return src;
  if (!src.includes("scene7.com")) return src;
  // Avoid double-applying the modifier.
  if (/[?&]wid=/.test(src)) return src;
  const sep = src.includes("?") ? "&" : "?";
  return `${src}${sep}wid=${targetSize}&hei=${targetSize}&fit=constrain&qlt=95`;
};

export const removeMagnifierGlass = () => {
  const glasses = document.getElementsByClassName("img-magnifier-glass");
  // Iterate from the end since the collection is live and shrinks as we remove
  for (let i = glasses.length - 1; i >= 0; i--) {
    glasses[i].parentNode?.removeChild(glasses[i]);
  }
};

export const magnify = (imgID, zoom, hiResSrc, otherSource) => {
  let img, glass, w, h, bw;
  img = document.getElementById(imgID);
  /*create magnifier glass:*/
  glass = document.createElement("DIV");
  glass.setAttribute("class", "img-magnifier-glass");
  /*insert magnifier glass:*/
  img.parentElement.insertBefore(glass, img);
  /*set background properties for the magnifier glass:
    Use a higher-resolution variant of the source image so that the zoomed
    view stays sharp instead of becoming blurry/pixelated.*/
  const targetPx = Math.max(
    2000,
    Math.ceil((img.naturalWidth || img.width) * zoom)
  );
  const bgSrc = otherSource
    ? img.src
    : getHiResImageSrc(hiResSrc || img.src, targetPx);
  glass.style.backgroundImage = "url('" + bgSrc + "')";
  glass.style.backgroundRepeat = "no-repeat";
  glass.style.backgroundSize =
    img.width * zoom + "px " + img.height * zoom + "px";
  bw = 3;
  w = glass.offsetWidth / 2;
  h = glass.offsetHeight / 2;
  /*execute a function when someone moves the magnifier glass over the image:*/
  glass.addEventListener("mousemove", moveMagnifier);
  img.addEventListener("mousemove", moveMagnifier);
  /*and also for touch screens:*/
  glass.addEventListener("touchmove", moveMagnifier);
  img.addEventListener("touchmove", moveMagnifier);
  function moveMagnifier(e) {
    let pos, x, y;
    /*prevent any other actions that may occur when moving over the image*/
    e.preventDefault();
    /*get the cursor's x and y positions:*/
    pos = getCursorPos(e);
    x = pos.x;
    y = pos.y;

    // w and h represent half the width and height of the glass
    let halfW = w;
    let halfH = h;

    /* ALLOW THE LENS TO HANG HALFWAY OUT:
       The cursor can now move to the absolute edges (0 to img width/height) */
    if (x > img.width) {
      x = img.width;
    }
    if (x < 0) {
      x = 0;
    }
    if (y > img.height) {
      y = img.height;
    }
    if (y < 0) {
      y = 0;
    }

    /*set the position of the magnifier glass:*/
    glass.style.left = x - halfW + "px";
    glass.style.top = y - halfH + "px";

    /*display what the magnifier glass "sees":*/
    glass.style.backgroundPosition =
      "-" + (x * zoom - halfW + bw) + "px -" + (y * zoom - halfH + bw) + "px";
  }

  function getCursorPos(e) {
    let a,
      x = 0,
      y = 0;
    e = e || window.event;
    /*get the x and y positions of the image:*/
    a = img.getBoundingClientRect();
    /*calculate the cursor's x and y coordinates, relative to the viewport:*/
    x = e.clientX - a.left;
    y = e.clientY - a.top;
    return { x: x, y: y };
  }
};

export const DEFAULT_IMAGE_LINK =
  "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";

export const PRODUCT_RESOURCE_TYPE_SPEC_DOC = "SpecPDFFileName";
export const PRODUCT_RESOURCE_TYPE_VIDEO = [
  "YouTubeVideo",
  "YouTubeInstallVideo",
];
export const TECHNICAL_INFORMATION_FILES = [
  "InstallationWithoutSPPDF",
  "SpecPDFFileName",
  "HomeownersGuide",
  "PartsPDFFileName",
];
export const TECHNICAL_INFORMATION_FILES_NAMES = {
  th: {
    SpecPDFFileName: "Rough in/Spec Sheet",
    matchingListPDFFileName: "รายการที่ตรงกัน",
    HomeownersGuide: "Home owners guide",
    InstallationWithoutSPPDF: "Installation Instruction",
    PartsPDFFileName: "ผลการทดสอบรังสี",
    InteractiveSVG: "Interactive parts diagram",
    HomeguideWithoutSPPDF: "Home owners guide without service part",
  },
  en: {
    SpecPDFFileName: "Rough in/Spec Sheet",
    matchingListPDFFileName: "Matching List",
    HomeownersGuide: "Home owners guide",
    InstallationWithoutSPPDF: "Installation Instruction",
    PartsPDFFileName: "Service Parts",
    InteractiveSVG: "Interactive parts diagram",
    HomeguideWithoutSPPDF: "Home owners guide without service part",
  },
};
export const PRODUCT_GIF_LINE_ART_IMAGE = "GIFLineArt";
export const PRODUCT_CAROUSEL_IMAGE = "IMGITEMISO";
export const PRODUCT_Cut_Out_DXF = "CutOutDXF";
export const PRODUCT_BIMRevit = "3DRevit";
export const PRODUCT_PLAN_3D = [
  "3DRevit",
  "3DSketchup",
  "3DDXF",
  "3DDWG",
  "3D3DS",
  "3DOBJ",
];
export const PRODUCT_PLAN_NAME_3D = {
  "3DRevit": "Revit",
  "3DSketchup": "Sketchup",
  "3DDXF": "DXF",
  "3DDWG": "DWG",
  "3D3DS": "3DS",
  "3DOBJ": "OBJ",
};
export const PRODUCT_FRONT_NAME_2D = {
  DWGFrontView: "DWG",
  DXFFrontView: "DXF",
};
export const PRODUCT_PLAN_NAME_2D = {
  DWGPlanView: "DWG",
  DXFPlanView: "DXF",
};
export const PRODUCT_SIDE_NAME_2D = {
  DWGSideView: "DWG",
  DXFSideView: "DXF",
};
export const PRODUCT_Front_View_2D = ["DWGFrontView", "DXFFrontView"];
export const PRODUCT_Plan_View_2D = ["DWGPlanView", "DXFPlanView"];
export const PRODUCT_Side_View_2D = ["DWGSideView", "DXFSideView"];
export const PRODUCT_ADDITIONAL_IMAGE = [
  "IMGTOP",
  "IMGFront",
  "IMGSide",
  "IMGCLOSEROOMVIEW",
  "IMGOVERHEADROOMVIEW",
  "IMGCLOSEROOMVIEWInUse",
  "IMGCLOSEROOMVIEWProductDetail",
  "IMGCLOSEROOMVIEWWithWaterEffects",
  "IMGCLOSEROOMVIEWWithWaterEffects",
  "IMGPARTIALROOMVIEW",
  "IMGDetail1",
  "IMGDetail2",
  "IMGDetail3",
  "IMGDetail4",
  "IMGDetail5",
  "IMGDetail6",
  "IMGGlam",
];

export const PDP_LABELS = {
  th: {
    technology: "เทคโนโลยี",
    colorName: "สี :",
    compareLabel: "เปรียบเทียบ",
    breadCrumbBackLabel: "ย้อนกลับ",
    storelocatorButtonLabel: "ค้นหาร้านค้า",
    findAStoreLabel: "ค้นหาร้านค้า",
    enquiryLabel: "สอบถามเพิ่มเติม",
    contactUsLabel: "ติดต่อเรา",
    home: "หน้าแรก",
    specFileLabel: "มิติข้อมูล & วัด",
    characteristics: "คุณสมบัติ",
    installation: "การติดตั้ง",
    material: "วัสดุ",
    resources: "ทรัพยากร",
    cadTemplate: "CAD เทมเพลต",
    cadFiles2D: "2D CAD Files:",
    plan: "วางแผน",
    front: "ด้านหน้า",
    overall: "ทั้งหมด",
    side: "ด้านข้าง",
    cadFiles3D: "3D CAD Files:",
    supportService: "บริการ & สนับสนุน",
    supportServiceQ: "มีคำถามเกี่ยวกับผลิตภัณฑ์นี้หรือไม่?",
    contactUs: "โทรหาเรา:",
    contactUsNumber: "+001-920 451 4418 ext. 74418",
    contactUsNumberLink: "tel:+0019204514418,74418",
    contactUsTime: "8:00 - 17:00 (เวลาเวียดนาม)",
    contactUsDay: "วันจันทร์ถึงวันศุกร์",
    emailUS: "ส่งอีเมลถึงเรา",
    careAndCleaning: "เคล็ดลับการดูแลรักษาทำความสะอาด",
    careCleaningLink: "การดูแลรักษาและการทำความสะอาด",
    guarantee: "ข้อมูลการรับประกัน",
    warrantyLink: "การรับประกัน",
    technicalInformation: "ข้อมูลทางเทคนิค",
    dimension: "ขนาด:",
    paresWellWith: "จับคู่ได้อย่างลงตัวกับ",
    similarProducts: "ผลิตภัณฑ์ที่คล้ายกัน",
    cutOutTemplates: "แม่แบบคัตเอาต์",
    bimRevit: "BIM Revit",
    twitterText: "ฉันกำลังแชร์บน Twitter!",
    collection: "คอลเลกชัน:",
    availableAt: "มีจำหน่ายที่:",
    discontinued: "ผลิตภัณฑ์นี้เลิกผลิตแล้ว",
    productDisclaimer:
      "โปรดทราบว่าผลิตภัณฑ์บางอย่างไม่สามารถใช้ได้ในทุกตลาด สำหรับข้อมูลเพิ่มเติมเกี่ยวกับความพร้อมใช้งานกรุณาติดต่อตัวแทนจำหน่ายในพื้นที่ของคุณ",
    supportServiceDesc: `ติดต่อ  <a href="/th/storelocator" target="_blank" class="text-[#337ab7] cursor-pointer no-underline hover:!no-underline"> ผู้จัดจำหน่ายในท้องถิ่น </a> หรือ <a href="/th/contact-us" target="_blank" class="hover:!no-underline text-[#337ab7] cursor-pointer no-underline"> สำนักงานในท้องถิ่น </a> องเรา ข้อมูลเพิ่มเติม`,
    featureRetailers: "ผู้ค้าปลีกที่โดดเด่น:",
    buyNow: "ซื้อเลย",
  },
  en: {
    technology: "Technology",
    colorName: "Color:",
    compareLabel: "Compare",
    breadCrumbBackLabel: "Back",
    contactUsLabel: "Contact Us",
    home: "Home",
    storelocatorButtonLabel: "Store Locator",
    findAStoreLabel: "Find a Store",
    enquiryLabel: "Enquire with Us",
    specFileLabel: "Dimensions & Measurements",
    characteristics: "Features",
    installation: "Installation",
    material: "Material",
    resources: "Resources",
    cadTemplate: "CAD Templates",
    cadFiles2D: "2D CAD Files:",
    plan: "Plan",
    front: "Front",
    overall: "Overall",
    side: "Side",
    cadFiles3D: "3D CAD Files:",
    supportService: "Service & Support",
    supportServiceQ: "Have a question about this product?",
    supportServiceDesc: `Contact a <a href="/en/storelocator" target="_blank" class="text-[#337ab7] cursor-pointer no-underline hover:!no-underline">local distributor</a> or our  <a href="/en/contact-us" target="_blank" class="hover:!no-underline text-[#337ab7] cursor-pointer no-underline">local offices</a> for more information`,
    contactUs: "Call us:",
    contactUsNumber: "1800-103-2244",
    contactUsNumberLink: "tel:+1800-103-2244",
    contactUsTime: "10:00hrs to 18:00hrs (IST)",
    contactUsDay: "Monday to Saturday",
    emailUS: "Email Us",
    careAndCleaning: "Care and Cleaning tips",
    careCleaningLink: "care-and-cleaning",
    guarantee: "Warranty Information",
    warrantyLink: "warranty",
    technicalInformation: "Technical Information",
    dimension: "Dimensions",
    paresWellWith: "Pairs Well With",
    similarProducts: "Similar Products",
    cutOutTemplates: "Cut out Templates",
    bimRevit: "BIM Revit",
    twitterText: "I am sharing on twitter!",
    collection: "Collection",
    technology: "Technology",
    availableAt: "Available at:",
    discontinued: "This product has been discontinued.",
    productDisclaimer:
      "Please note that not all products are available in all markets. For more information on availability, please contact your local distributor.",
    featureRetailers: "Featured retailers:",
    buyNow: "Buy Now",
  },
  "en-US": {
    colorName: "Color:",
    home: "Home",
    storelocatorButtonLabel: "Store Locator",
    findAStoreLabel: "Find a Store",
    enquiryLabel: "Enquire with Us",
    specFileLabel: "Dimensions & Measurements",
    characteristics: "Features",
    installation: "Installation",
    material: "Material",
    resources: "Resources",
    cadTemplate: "CAD Templates",
    cadFiles2D: "2D CAD Files:",
    plan: "Plan",
    front: "Front",
    overall: "Overall",
    side: "Side",
    cadFiles3D: "3D CAD Files:",
    supportService: "Service & Support",
    supportServiceQ: "Have a question about this product?",
    supportServiceDesc: `Contact a <a href="/en/storelocator" target="_blank" class="text-[#337ab7] cursor-pointer no-underline hover:!no-underline">local distributor</a> or our  <a href="/en/contact-us" target="_blank" class="hover:!no-underline text-[#337ab7] cursor-pointer no-underline">local offices</a> for more information`,
    contactUs: "Call us:",
    contactUsNumber: "1800-103-2244",
    contactUsNumberLink: "tel:+1800-103-2244",
    contactUsTime: "10:00hrs to 18:00hrs (IST)",
    contactUsDay: "Monday to Saturday",
    emailUS: "Email Us",
    careAndCleaning: "Care and Cleaning tips",
    careCleaningLink: "care-and-cleaning",
    guarantee: "Warranty Information",
    warrantyLink: "warranty",
    technicalInformation: "Technical Information",
    dimension: "Dimensions",
    paresWellWith: "Pairs Well With",
    similarProducts: "Similar Products",
    cutOutTemplates: "Cut out Templates",
    bimRevit: "BIM Revit",
    twitterText: "I am sharing on twitter!",
    collection: "Collection",
    technology: "Technology",
    availableAt: "Available at:",
    discontinued: "This product has been discontinued.",
    productDisclaimer:
      "Please note that not all products are available in all markets. For more information on availability, please contact your local distributor.",
  },
};

export const thumbsImageFormatter = (url, isNewProduct, type) => {
  if (PRODUCT_RESOURCE_TYPE_VIDEO.includes(type)) {
    return `http://img.youtube.com/vi/${url}/hqdefault.jpg`;
  } else {
    return carouselImageFormatter(url, isNewProduct);
  }
};

export const pdpImagesHandler = pdpData => {
  if (pdpData?.["productImages.labelWithUrl_ss"]?.length > 0) {
    const imagesUrlAndAlt = pdpData?.["productImages.labelWithUrl_ss"]?.map(
      imageUrlandAlt => {
        const imageUrl = imageURLWithPresetConfigPDP(
          imageUrlandAlt.split("|")[1]
        );
        const imageAlt = imageUrlandAlt.split("|").slice(-2)[0];
        const imageSku = imageUrlandAlt.split("|").slice(-6)[0];

        return {
          src: imageUrl,
          alt: imageAlt,
          sku: imageSku,
          fallBackSrc: imageUrlandAlt.split("|").slice(-1)[0],
        };
      }
    );

    // If the last entry is the shared variant image (IMGVariant- prefix)
    const lastItem = imagesUrlAndAlt[imagesUrlAndAlt.length - 1];
    if (lastItem?.sku?.startsWith("IMGVariant-")) {
      const skuOnlyEntries = imagesUrlAndAlt.slice(0, -1);
      const uniqueSkus = [...new Set(skuOnlyEntries.map(e => e.sku))];
      const variantCopies = uniqueSkus.map(sku => ({
        src: lastItem.src,
        alt: lastItem.alt,
        sku,
      }));
      return [...skuOnlyEntries, lastItem, ...variantCopies];
    }

    return imagesUrlAndAlt;
  } else {
    const imageUrl =
      "https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is%7BPAWEB%2Fdefault%7D";
    const imageAlt = "No images yet, coming soon";
    return [
      {
        src: imageUrl,
        alt: imageAlt,
      },
    ];
  }
};

export const getColorSwatches = pdpData => {
  const color = pdpData?.["Color.SKU.Details_ss"]?.map(colorSwatches => {
    const skuid = colorSwatches.split("|")[2];
    const swatchSrc = colorSwatches.split("|")[1];
    const styleName = colorSwatches.split("|")[0];
    const swatchPrice = pdpData?.["Color.GST.Details_ss"]?.filter(swatchClr => {
      if (swatchClr.split("|")?.[0] === skuid) {
        return swatchClr;
      }
    });
    return {
      skuid: skuid,
      price: swatchPrice?.[0]?.split("|")?.[2],
      styleName: styleName !== "N/A" ? styleName : null,
      src: `https://kohler.scene7.com/is/image/PAWEB/${swatchSrc}`,
    };
  });
  return color;
};

export const getColorSwatchesPLPModal = pdpData => {
  const color = pdpData?.["Color.SKU.Details_ss"]?.map(colorSwatches => {
    const skuid = colorSwatches.split("|")[2];
    const swatchSrc = colorSwatches.split("|")[1];
    const styleName = colorSwatches.split("|")[0];
    const swatchName = colorSwatches.split("|")[1];
    const swatchPrice = pdpData?.["Color.GST.Details_ss"]?.filter(swatchClr => {
      if (swatchClr.split("|")?.[0] === skuid) {
        return swatchClr;
      }
    });
    return {
      skuid: skuid,
      price: swatchPrice?.[0]?.split("|")?.[2],
      styleName: styleName !== "N/A" ? styleName : null,
      swatchName: swatchName !== "N/A" ? swatchName : null,
      src: `https://kohler.scene7.com/is/image/PAWEB/${swatchSrc}`,
    };
  });
  return color;
};

export const imageURLWithPresetConfigPDP = (assetId = "") => {
  return `https://kohler.scene7.com/is/image/PAWEB/Category_Template?$PDPcon$&$gradient_src=PAWEB%2Forganic-gradient&$shadow_src=PAWEB%2FBlank&$Badge1_src=PAWEB%2FBlank&$Badge4_src=PAWEB%2FBlank&$Badge3_src=PAWEB%2FBlank&$Badge2_src=PAWEB%2FBlank&$product_src=is{PAWEB%2F${assetId}}&defaultImage=force_error_state`;
};
